import { combineReducers } from '@reduxjs/toolkit';
import { ReportingState } from './types';
import { reportingBatchSlice } from '../batch/store/slice';
import { reportingSlice } from './slice';
import { newReportsSlice } from 'src/features/clients/client/reportsV2/store/slice';
import { schedulerSlice } from '../scheduler/store/slice';

export const reportingReducer = combineReducers<ReportingState>({
  batch: reportingBatchSlice.reducer,
  bulk: reportingSlice.reducer,
  reports: newReportsSlice.reducer,
  scheduler: schedulerSlice.reducer,
});
